import request from '@/utils/request'

/**
 * 获取终端设定配置信息列表
 */
function getTerminalConfigList(data) {
    return request({
        url:'/obdConfig/list',
        method:'post',
        data
    })
}

/**
 * 新增 终端设定配置信息
 */
function createTerminalConfig(data) {
    return request({
        url:'/obdConfig',
        method:'post',
        data
    })
}

/**
 * 编辑 终端设定配置信息
 */
function updateTerminalConfig(terminalId,data) {
    return request({
        url:`/obdConfig/${terminalId}`,
        method:'put',
        data
    })
}
/**
 * 获取 95OBD设备列表
 */
function getNineFiveOBDList(data){
    return request({
        url:'/obdConfig/95OBD/list',
        method:'post',
        data
    })
}
/**
 * 获取 95OBD设备配置详情
 */
function getNineFiveOBD(terminalId){
    return request({
        url:`/obdConfig/95OBD/${terminalId}`,
        method:'get'
    })
}
/**
 * 删除 终端设定配置信息
 */
function deleteTermianlConfig(id) {
    return request({
        url:`/obdConfig/${id}`,
        method:'delete'
    })
}
export {
    getTerminalConfigList,
    createTerminalConfig,
    updateTerminalConfig,
    deleteTermianlConfig,
    getNineFiveOBDList,
    getNineFiveOBD
}